import { portalApi } from "./client";
import type { PortalMaterialDownloadDto, PortalMaterialDto } from "./types";

// Remediation Tier 2 #9 (Prompt 9-ii) — recipient-side materials feed
// for Buyer / Seller / Vendor sessions. The backend reads the session's
// AccountType and filters Audience IN (accountType, All). Brokers use
// the existing /api/portal/broker/materials surface (which gates on
// certification); this client refuses to be called from a broker
// session in callers.

export const portalMaterialsRecipientApi = {
  list: () => portalApi.get<PortalMaterialDto[]>("/materials"),
  download: (id: string) =>
    portalApi.get<PortalMaterialDownloadDto>(`/materials/${id}/download`),
};
